const Files = {
  TemplateDoc: require("./../assets/Template-10.doc").default,
};

export default Files;
